import {
  Animated,
  ImageBackground,
  Image,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  ScrollView,
  Switch,
  useWindowDimensions,
} from "react-native";
import { useEffect, useRef, useState } from "react";
import {
  BtnSidebarClosePng,
  InputField,
  GameRulesTitle,
  ProfileTitlePopup,
  SaveBtn,
  SearchTitlePng,
  ProfileRegistration,
  GameRulesLight,
  RulesBackground,
  ToggleKnobPng,
  ToggleBgPng,
  PersonalDataTitle,
  ModalTitle,
} from "../../../assets";
import SvaraModal from "../Modals/SvaraModal";
import GameRuleSection from "./GameRulesModalComponents/GameRuleSection";
import { useDevice } from "../../../utils/hooks/useDevice";
import { RenderToggle } from "./RenderToggle";
import { useTranslation } from "react-i18next";
import ModalReusable from "./ModalReusable";

interface IProps {
  onClose: () => void;
}

const PersonalDataModal = ({ onClose }: IProps) => {
  const opacity = useRef(new Animated.Value(0)).current;
  const { isDesktop } = useDevice();
  const [marketing, setMarketing] = useState(true);
  const [offers, setOffers] = useState(true);
  const [terms, setTerms] = useState(true);
  const { width } = useWindowDimensions();
  const isMobile = width < 600;
  const { t } = useTranslation();
  const raw = width * 0.6;
  const titleWidth = Math.max(250, raw);

  useEffect(() => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 200,
      useNativeDriver: true,
    }).start();

    return () => {
      opacity.setValue(0);
    };
  }, []);

  const handleClose = () => {
    Animated.timing(opacity, {
      toValue: 0,
      duration: 200,
      useNativeDriver: true,
    }).start(() => {
      onClose();
    });
  };

  return (
    <>
      <ModalReusable
        visible
        onClose={onClose}
        // backgroundImage={RulesBackground}
        titleImage={ModalTitle}
        title={t("T_SITE_MENU_PERSONAL_DATA")}
        titleImageStyles={
          isMobile
            ? {
                width: titleWidth,
                minWidth: 250,
                height: 90,
                top: -55,
                // transform: [{ translateX: -titleWidth / 2 }],
              }
            : {
                width: titleWidth,
                minWidth: 380,
                height: 90,
                top: -55,
              }
        }
        titleTextStyles={{
          width: 380,

          fontSize: 18,
          marginTop: -6,
          textAlign: "center",
          transform: [{ translateX: -380 / 2 }, { translateY: -10 }],
        }}
        closeIcon={BtnSidebarClosePng}
        closeButtonSize="small"
      >
        <ScrollView style={[styles.wrap, { maxWidth: isDesktop ? 1000 : 360 }]}>
          <Text style={styles.text}>{t("T_SITE_DATA_CONTROL_SUBTITLE")}</Text>

          {/* Row 1 */}
          <View style={styles.row}>
            <View style={{ minWidth: 120, width: isDesktop ? "50%" : 200 }}>
              <Text style={[styles.text, { fontSize: isDesktop ? 14 : 14 }]}>
                {t("T_SITE_DATA_CONTROL_MARKETING_INFO")}
              </Text>
            </View>
            <View style={{ minWidth: 120 }}>
              <RenderToggle
                value={marketing}
                onChange={() => setMarketing(!marketing)}
              />
            </View>
          </View>

          {/* Row 2 */}
          <View style={styles.row}>
            <View style={{ minWidth: 120, width: isDesktop ? "50%" : 200 }}>
              <Text style={styles.text}>
                {t("T_SITE_DATA_CONTROL_TARGETING_INFO")}
              </Text>
            </View>
            <View style={{ minWidth: 120 }}>
              <RenderToggle
                value={offers}
                onChange={() => setOffers(!offers)}
              />
            </View>
          </View>

          {/* Terms */}
          <View style={styles.row}>
            <View style={{ minWidth: 120, width: isDesktop ? "50%" : 200 }}>
              <Text style={styles.text}>
                <Text> </Text>
                <Text style={styles.link}>
                  {" "}
                  {t("T_SITE_DATA_CONTROL_TERMS_LINK")}
                </Text>
                <Text> {t("T_SITE_DATA_CONTROL_TERMS_AND")}</Text>
                <Text style={styles.link}>
                  {t("T_SITE_DATA_CONTROL_PRIVACY_LINK")}
                </Text>
                <Text> {t("T_SITE_DATA_CONTROL_TERMS_INFO")}</Text>
              </Text>
            </View>
            <View style={{ minWidth: 120 }}>
              <RenderToggle value={terms} onChange={() => setTerms(!terms)} />
            </View>
          </View>

          {/* Last line */}
          <Text style={styles.text}>
            {t("T_SITE_DATA_CONTROL_DATA_COPY")}
            <Text style={styles.link}>
              {" "}
              {t("T_SITE_DATA_CONTROL_PRIVACY_LINK")}
            </Text>
          </Text>
        </ScrollView>
      </ModalReusable>
    </>
  );
};

export default PersonalDataModal;

const styles = StyleSheet.create({
  wrap: {
    padding: 16,
    gap: 24,
  },
  text: {
    color: "#cdd6e6",
    fontSize: 14,
    lineHeight: 22,
  },
  link: {
    color: "#3AD9FF",
    textDecorationLine: "underline",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
  },
});
